import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import Skeleton from '@/components/ui/skeleton'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet'
import { Glossary } from './glossary-card'

/** 页头按钮 + 右侧抽屉：正文不常看的内容收进这里（MON-68） */
function PageSheet({ label, count, title, description, children }) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button type="button" variant="outline" size="sm">
          {label}
          {count != null && (
            <Badge variant="outline" className="h-5 px-1.5 text-xs font-medium tabular-nums">{count}</Badge>
          )}
        </Button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="flex w-full flex-col sm:max-w-xl"
        {...(description ? {} : { 'aria-describedby': undefined })}
      >
        <SheetHeader className="pr-6">
          <SheetTitle>{title}</SheetTitle>
          {description && <SheetDescription>{description}</SheetDescription>}
        </SheetHeader>
        <div className="-mx-6 flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-6 pb-2">{children}</div>
      </SheetContent>
    </Sheet>
  )
}

function Pending() {
  return <Skeleton role="status" className="h-48 rounded-xl" />
}

/** 排除说明按钮：count 为该页排除格子行数，数据未到时传 null 不显示角标、内容显示占位 */
export function ExclusionSheet({ count, children }) {
  return (
    <PageSheet label="排除说明" count={count} title="排除说明">
      {children ?? <Pending />}
    </PageSheet>
  )
}

/** 术语与公式按钮：data 为本页口径数据，用于末尾「本页信息」（MON-89） */
export function GlossarySheet({ formulas, data }) {
  return (
    <PageSheet label="术语与公式" title="术语与公式">
      <Glossary formulas={formulas} data={data} />
    </PageSheet>
  )
}
